import StrapiV4Video from '../../atoms-components/video/video'
import Text from '@/stories/components/Common/NewText'
import { YoutubeCardType } from '@/root/utils/articles/types'

const YoutubeCard = ({ card }: { card: YoutubeCardType }) => {
  return (
    <div className="lg:min-w-1/3 xs:w-full xs:min-w-full rounded-3xl bg-white sm:w-full sm:min-w-full lg:min-h-[240px]">
      {card.videoId && <StrapiV4Video data={card} no_padding />}

      <div className="px-4 pb-4">
        <Text className="lg:text-20px my-2 font-normal" tag="h3">
          {card.title}
        </Text>
      </div>
    </div>
  )
}

export default YoutubeCard
